// borders are in px, everything else in rem
export default {
  mainHeaderHeight: 5,
  documentSelectorHeightOpen: 15.4,
  documentSelectorHeightClosed: 2.6,
  documentSelectorBorderHegiht: 1,
  checklistHeaderHeight: 3.6,
};
